import { render, staticRenderFns } from "./BCXPanelFullscreenMobile.vue?vue&type=template&id=41201c67&scoped=true"
import script from "./BCXPanelFullscreenMobile.vue?vue&type=script&lang=ts"
export * from "./BCXPanelFullscreenMobile.vue?vue&type=script&lang=ts"
import style0 from "./BCXPanelFullscreenMobile.vue?vue&type=style&index=0&id=41201c67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41201c67",
  null
  
)

export default component.exports